/*
 *  -----------------------------------------------------------------------
 *    <copyright file="report-tile.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { useTranslation } from 'hooks';
import { showMaxLength } from 'utils/filter';

import './styles.scss';

const ReportTile = ({
    showView,
    showDownload,
    showInternal,
    title,
    description,
    onClick,
    'data-testid': dataTestId,
}: {
    showView?: boolean;
    showDownload?: boolean;
    showInternal?: boolean;
    title: string;
    description: string;
    onClick?: (any: any) => any;
    'data-testid': string;
}) => {
    const { t } = useTranslation();

    return (
        <div className="tile-report-wrapper" data-testid={dataTestId}>
            <div className="header">
                <div className="title-internal">
                    <div className="title">{title}</div>
                    {showInternal ? <div className="internal-wrapper">{t('internal')}</div> : null}
                </div>
                <div className="icon-wrap">
                    {showView ? (
                        <FontAwesomeIcon
                            icon={['far', 'eye']}
                            className="report-icon eye"
                            onClick={onClick}
                            data-testid="view-button"
                        />
                    ) : null}
                    {showDownload ? (
                        <FontAwesomeIcon
                            icon={['fal', 'download']}
                            className="report-icon"
                            onClick={onClick}
                            data-testid="download-button"
                        />
                    ) : null}
                </div>
            </div>
            <div className="content">{showMaxLength(description, 175)}</div>
        </div>
    );
};

export default ReportTile;
